import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { PaymentData } from "../types";

export const updatePaymentApi = (userId: string, payment: PaymentData) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "clearing/updpayment",
    params: {
      userId,
    },
    data: payment,
  });

export default updatePaymentApi;
